
      import API from "!../../style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../../style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../css-loader/dist/cjs.js??ruleSet[1].rules[4].use[1]!./virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{\"fileName\":\"app/components/header/cart-drawer/styles.css.ts.vanilla.css\",\"source\":\"LnEwc2NtbTAgewogIHdpZHRoOiAxMDAlIWltcG9ydGFudDsKfQoucTBzY21tMSB7CiAgdHJhbnNmb3JtOiB0cmFuc2xhdGUoMTAwJSk7Cn0KLnEwc2NtbTIgewogIHRyYW5zZm9ybTogdHJhbnNsYXRlKDBweCk7Cn0KLnEwc2NtbTMgewogIGFsaWduLWl0ZW1zOiBjZW50ZXI7CiAgYmFja2dyb3VuZC1jb2xvcjogdmFyKC0tXzE4dzc2YncyNik7CiAgei1pbmRleDogMTAwMDsKfQpAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiA3NjhweCkgewogIC5xMHNjbW0wIHsKICAgIHdpZHRoOiAzMjBweCFpbXBvcnRhbnQ7CiAgfQp9\"}!./extracted.js";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;

      options.insert = insertFn.bind(null, "head");
    
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../css-loader/dist/cjs.js??ruleSet[1].rules[4].use[1]!./virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{\"fileName\":\"app/components/header/cart-drawer/styles.css.ts.vanilla.css\",\"source\":\"LnEwc2NtbTAgewogIHdpZHRoOiAxMDAlIWltcG9ydGFudDsKfQoucTBzY21tMSB7CiAgdHJhbnNmb3JtOiB0cmFuc2xhdGUoMTAwJSk7Cn0KLnEwc2NtbTIgewogIHRyYW5zZm9ybTogdHJhbnNsYXRlKDBweCk7Cn0KLnEwc2NtbTMgewogIGFsaWduLWl0ZW1zOiBjZW50ZXI7CiAgYmFja2dyb3VuZC1jb2xvcjogdmFyKC0tXzE4dzc2YncyNik7CiAgei1pbmRleDogMTAwMDsKfQpAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiA3NjhweCkgewogIC5xMHNjbW0wIHsKICAgIHdpZHRoOiAzMjBweCFpbXBvcnRhbnQ7CiAgfQp9\"}!./extracted.js";
       export default content && content.locals ? content.locals : undefined;
